import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHandlerFn, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, finalize, Observable, tap } from 'rxjs';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { GeneralEmitterService } from '../services/general-emitter.service';
import { error } from 'console';
import { MessageService } from 'primeng/api';

export const AuthInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next:HttpHandlerFn):Observable<HttpEvent<any>> => {
  const emitterService = inject(GeneralEmitterService); // Inject the emitterService

  emitterService.showSpinner.emit(true);
  
  const SECRET_TOKEN = "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE3MjA1NTE0NDIsImF1ZCI6WyJodHRwczovL2FwaS11cy13ZXN0LTIuaHlncmFwaC5jb20vdjIvY2x5ZHB2dHp4MDdtdjA3dXI1bjdqam44Zi9tYXN0ZXIiLCJtYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC11cy13ZXN0LTIuaHlncmFwaC5jb20vIiwic3ViIjoiMjkyMjk2NmMtOTdmOS00NWQ1LTgxNzItMDkxN2VhOTZlMGE2IiwianRpIjoiY2x5ZXJ3bDdjMDRsdDA4bHBkYXU2YXlrOSJ9.wPtitkVwhjOBAfkHV01RmLRI3dQEqezmzO9h4CyI2QKAkCCykJgg_t8QCVfyTjzTIyHnS-C2zYcOE7m352P6bbwaKE6xNlq1CsYUeI4U_cd0n68AEBllxQQzoPPOo00NUFBD2iFolNZqdhkMqClipu9i0pa81z4qBQRLj6hLMbznMQauub977nAdzhKZG7UepUjI4hXIQ3T7b0wEry8Ylo7QD04uzxFjLK5ZbtX7hmYi9CGO2RrIVrXFeqjwadwEzIut7mLD8prchWJh72ua4_Aa4j74jhHuxSy4_EEMgeB-CIEtaNKYL53x4uhbPN28Ux_cMbJG8rN3f6I1ETu7HATDK7QCBX8OyVslPbVMo-e5Fxm69y2V2GwkNNjnAYbWDI8O_S6XlAj0JMRMCusJ3bu-Xr1FXDwMBLFQrgk6QqipTveOECr9uoy12_PoSjWNq9cf4IlbLomzrgChamAGnP23zopctK70mIrbQmR8q1A39trvgCIANSVUU2-J2ijLXU7CFJsCefKRY1wjX-TCFKcMZ688-jxn5zwyRR3qbjP9_xRnRMaJZBO97MZhvGvCJc5-Rs9PBVhCRwa5mB4MDUf5hs4T5xb9tDZmj-xIlT1mR-BmRJxxFGlVLaoVS_uWhbkJ02rGCb42mnYH9kt-4hpZLhYLpa5UK6GShBUj7K0";

  let sendRefresh: boolean = false;

  let headers = new HttpHeaders({
    Authorization	: `Bearer ${localStorage.getItem('id_token_api')}`,
  });

  let cloned: HttpRequest<any> | null = null
  
  const helper: JwtHelperService = new JwtHelperService();
  const tokenApi = localStorage.getItem('id_token_api') ?? '';
  const expiredToken: boolean = helper.isTokenExpired(tokenApi);

  console.log('expiredToken :', expiredToken);
  if( expiredToken ) {
    let url = `${environment.apiService}/api/logout`
    headers = new HttpHeaders({
			Authorization	: `Bearer ${localStorage.getItem('id_token_api')}`,
		});

		cloned = req.clone({
			headers	: headers,
			url		: url,
		});

    localStorage.removeItem('id_token_api');
    localStorage.removeItem('usr');
    
  }

  if (req.url.includes('/api')) {
    let url = `${environment.apiService}${req.url}`;
    headers = new HttpHeaders({
			Authorization	: `Bearer ${localStorage.getItem('id_token_api')}`,
		});

		cloned = req.clone({
			headers	: headers,
			url		: url,
		});
  } else {
    cloned = req.clone({
      setHeaders: {
        "Authorization": SECRET_TOKEN,
      },
    });
  }
 
  return next(cloned).pipe(
    finalize(() => {
      emitterService.showSpinner.emit(false);
      console.log('Request is complete!');
    })
  );
};
